export default "__VITE_ASSET__Ds9I6G0j__"